/* Animaciones de la portada. Solo se carga desde las secciones de inicio.
   No toca nada del resto del tema: se limita a body.template-index.        */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTORS = [
    '.section-head',
    '.value',
    '.product-grid > *',
    '.section-cta',
    '.cat-tile',
    '.home-stat',
    '.editorial-media',
    '.editorial-body',
    '.testimonial',
    '.faq-item',
    '.newsletter-inner'
  ].join(',');

  function markTargets(root) {
    var nodes = root.querySelectorAll(SELECTORS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-reveal')) continue;
      el.setAttribute('data-reveal', '');
      // Escalonado suave dentro de cada grupo de hermanos.
      var index = 0;
      var prev = el.previousElementSibling;
      while (prev && index < 6) { index++; prev = prev.previousElementSibling; }
      el.style.setProperty('--reveal-delay', (index * 80) + 'ms');
    }
  }

  var observer = null;

  function observe(root) {
    var nodes = root.querySelectorAll('[data-reveal]');
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-visible');
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    for (var j = 0; j < nodes.length; j++) observer.observe(nodes[j]);
  }

  /* Contadores: 0 -> valor final cuando entran en pantalla. */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var suffix = el.getAttribute('data-suffix') || '';
    var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
    if (isNaN(target)) return;
    if (reduce) {
      el.textContent = target.toLocaleString('es-ES', {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      }) + suffix;
      return;
    }
    var start = null;
    var duration = 1400;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString('es-ES', {
        minimumFractionDigits: decimals, maximumFractionDigits: decimals
      }) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var counterObserver = null;

  function observeCounters(root) {
    var nodes = root.querySelectorAll('[data-count]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) countUp(nodes[i]);
      return;
    }
    if (!counterObserver) {
      counterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          counterObserver.unobserve(entry.target);
        });
      }, { threshold: 0.4 });
    }
    for (var j = 0; j < nodes.length; j++) counterObserver.observe(nodes[j]);
  }

  /* Paralaje muy leve en la imagen de portada. */
  function parallax() {
    if (reduce) return;
    var media = document.querySelector('.template-index .hero-media');
    if (!media) return;
    var ticking = false;
    function update() {
      var y = window.scrollY || 0;
      if (y < window.innerHeight * 1.2) {
        media.style.translate = '0 ' + (y * 0.14).toFixed(1) + 'px';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
  }

  function init(root) {
    if (!document.body || document.body.className.indexOf('template-index') === -1) return;
    var scope = root || document;
    markTargets(scope);
    observe(scope);
    observeCounters(scope);
  }

  function boot() {
    init(document);
    parallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // El editor de temas recarga secciones sueltas: solo re-observamos esa sección.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
